// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-warning {
    color: #856404;
    background-color: #f8d7da;
    border-color: #f5c6cb;
    WIDTH: fit-content;
}

.cut-word {
    max-width: 25em !important;
}

.border {
    border: 1px solid #c9c9c9;
    padding: 20px;
    border-radius: 4px;
    position: relative;
    margin-top: 20px;
    color: #008fc7;
}

.pageLabel {
    color: #838383;
    font: 11px;
}

.CultureLabel {
    background: #008fc7;
    color: #f0f3ff;
}

.border-title {
    background: #ffffff;
    top: -11px;
    padding: 0 4px 0 8px;
    position: absolute;
    z-index: 0;
    height: 20px;
}

.dd {
    position: relative;
    display: block;
    margin: 0;
    padding: 0;
    max-width: 100%;
    list-style: none;
    font-size: 13px;
    line-height: 20px;
}

.dd-list {
    display: block;
    position: relative;
    margin: 0;
    padding: 0;
    list-style: none;
}

.dd-item,
.dd-empty,
.dd-placeholder {
    display: block;
    position: relative;
    margin: 0;
    padding: 0;
    min-height: 20px;
    font-size: 13px;
    line-height: 20px;
}

.dd3-handle {
    position: absolute;
    margin: 0;
    left: 0;
    top: 0;
    cursor: move;
    width: 30px;
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
    background: #fafafa;
    background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);
    /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */
    border-right: none;
}

.dd-handle {
    display: block;
    height: 30px;
    margin: 5px 0;
    padding: 5px 10px;
    color: #333;
    text-decoration: none;
    font-weight: bold;
    border: 1px solid #ccc;
    background: #fafafa;
    background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);
    /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */
    border-radius: 3px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.dd3-content {
    display: block;
    /* height: 30px; */
    margin: 5px 0;
    /* padding: 5px 30px 5px 40px; */
    color: #333;
    text-decoration: none;
    font-weight: bold;
    border: 1px solid #ccc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #fafafa;
    background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);
    /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */
    border-radius: 3px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
}

 ::ng-deep .categories-pages ng-select.ng-invalid.ng-touched .ng-select-container {
    border-color: #dc3545;
    animation-name: flush;
    animation-duration: 0.7s;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px #fde6e8;
}


/* new design */

.f-white {
    color: #fff
}

.accordion .card .card-header .card-title {
    transition: color ease 0.4s;
    color: grey;
    border: 1px solid #f6f6f6;
}

.accordion .card .card-header.published .card-title {
    color: #008fc7;
    background-color: #dff7ff !important;
    border: 1px solid #dff7ff !important;
}

.accordion .card .card-header .card-title:hover {
    /* box-shadow: 0px 0px 5px #006b9554; */
    cursor: pointer;
    background-color: #ececec !important;
    border: 1px solid #ececec !important
}
`, "",{"version":3,"sources":["webpack://./src/app/views/pages/add-edit-page/add-edit-page.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;;;IAGI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IAEnB,4DAA4D;IAC5D,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IAEnB,4DAA4D;IAC5D,6DAA6D;IAE7D,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IAEnB,4DAA4D;IAC5D,6DAA6D;IAE7D,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;AAC/B;;CAEC;IACG,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IACxB,mEAAmE;AACvE;;;AAGA,eAAe;;AAEf;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;IACvC,eAAe;IACf,oCAAoC;IACpC;AACJ","sourcesContent":[".alert-warning {\r\n    color: #856404;\r\n    background-color: #f8d7da;\r\n    border-color: #f5c6cb;\r\n    WIDTH: fit-content;\r\n}\r\n\r\n.cut-word {\r\n    max-width: 25em !important;\r\n}\r\n\r\n.border {\r\n    border: 1px solid #c9c9c9;\r\n    padding: 20px;\r\n    border-radius: 4px;\r\n    position: relative;\r\n    margin-top: 20px;\r\n    color: #008fc7;\r\n}\r\n\r\n.pageLabel {\r\n    color: #838383;\r\n    font: 11px;\r\n}\r\n\r\n.CultureLabel {\r\n    background: #008fc7;\r\n    color: #f0f3ff;\r\n}\r\n\r\n.border-title {\r\n    background: #ffffff;\r\n    top: -11px;\r\n    padding: 0 4px 0 8px;\r\n    position: absolute;\r\n    z-index: 0;\r\n    height: 20px;\r\n}\r\n\r\n.dd {\r\n    position: relative;\r\n    display: block;\r\n    margin: 0;\r\n    padding: 0;\r\n    max-width: 100%;\r\n    list-style: none;\r\n    font-size: 13px;\r\n    line-height: 20px;\r\n}\r\n\r\n.dd-list {\r\n    display: block;\r\n    position: relative;\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n}\r\n\r\n.dd-item,\r\n.dd-empty,\r\n.dd-placeholder {\r\n    display: block;\r\n    position: relative;\r\n    margin: 0;\r\n    padding: 0;\r\n    min-height: 20px;\r\n    font-size: 13px;\r\n    line-height: 20px;\r\n}\r\n\r\n.dd3-handle {\r\n    position: absolute;\r\n    margin: 0;\r\n    left: 0;\r\n    top: 0;\r\n    cursor: move;\r\n    width: 30px;\r\n    text-indent: 100%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    background: #fafafa;\r\n    background: -webkit-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n    background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n    /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */\r\n    border-right: none;\r\n}\r\n\r\n.dd-handle {\r\n    display: block;\r\n    height: 30px;\r\n    margin: 5px 0;\r\n    padding: 5px 10px;\r\n    color: #333;\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n    border: 1px solid #ccc;\r\n    background: #fafafa;\r\n    background: -webkit-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n    background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n    /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */\r\n    -webkit-border-radius: 3px;\r\n    border-radius: 3px;\r\n    box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n}\r\n\r\n.dd3-content {\r\n    display: block;\r\n    /* height: 30px; */\r\n    margin: 5px 0;\r\n    /* padding: 5px 30px 5px 40px; */\r\n    color: #333;\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n    border: 1px solid #ccc;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    background: #fafafa;\r\n    background: -webkit-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n    background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n    /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */\r\n    -webkit-border-radius: 3px;\r\n    border-radius: 3px;\r\n    box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n}\r\n\r\n ::ng-deep .categories-pages ng-select.ng-invalid.ng-touched .ng-select-container {\r\n    border-color: #dc3545;\r\n    animation-name: flush;\r\n    animation-duration: 0.7s;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px #fde6e8;\r\n}\r\n\r\n\r\n/* new design */\r\n\r\n.f-white {\r\n    color: #fff\r\n}\r\n\r\n.accordion .card .card-header .card-title {\r\n    transition: color ease 0.4s;\r\n    color: grey;\r\n    border: 1px solid #f6f6f6;\r\n}\r\n\r\n.accordion .card .card-header.published .card-title {\r\n    color: #008fc7;\r\n    background-color: #dff7ff !important;\r\n    border: 1px solid #dff7ff !important;\r\n}\r\n\r\n.accordion .card .card-header .card-title:hover {\r\n    /* box-shadow: 0px 0px 5px #006b9554; */\r\n    cursor: pointer;\r\n    background-color: #ececec !important;\r\n    border: 1px solid #ececec !important\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
